import React from 'react';
import PropTypes from 'prop-types';
import imgDefaultUser from '../../../../assets/img/default-user.png';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { CompanyLabel } from '../../shared/components/CompanyLabel';
import { WorkLabel } from '../../shared/components/WorkLabel';
import { WorkerLabel } from '../../shared/components/WorkerLabel';
import { MachineLabel } from '../../shared/components/MachineLabel';
import { DocumentLabel } from '../../shared/components/DocumentLabel';
import './MessageListItem.css';
import LinkButton from '../../../shared/components/LinkButton';

export class MessageListItem extends React.Component {

    render() {
        const { message } = this.props;

        return (
            <div className="ps-message-item">
                <div className="ps-message-avatar">
                    <img
                        src={message.userAvatar() || imgDefaultUser}
                        width="48"
                        height="48"
                        alt="User"
                        className="media-object user-image"
                    />
                </div>
                <div className="ps-message-labels">
                    <CompanyLabel company={message.company()}/>
                    <WorkLabel work={message.work()}/>
                    <WorkerLabel worker={message.worker()}/>
                    <MachineLabel machine={message.machine()}/>
                    <DocumentLabel document={message.document()}/>
                </div>
                <div className="ps-message-title">
                    {message.title()}
                </div>
                <div className="ps-message-body">
                    {message.body() || '-'}
                </div>
                <div className="ps-message-time">
                    <i className="material-icons">access_time</i>
                    <span>{message.dateDescription()}</span>
                </div>
                <div className="ps-message-button">
                    <LinkButton
                        to={RouterUtils.generateRoute(PsRoutes.MESSAGES_DETAIL, { id: message.id() })}
                        text={I18nUtils.tr('TR_VER_CONVERSACION')}
                        className={'btn btn-primary waves-effect'}
                    />
                </div>
            </div>
        );
    }
}

MessageListItem.propTypes = {
    message: PropTypes.object.isRequired,
};

MessageListItem.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/list/MessageListItem.jsx